import { RouteObject } from 'react-router';
import SettingsPage from './pages/update';
import { AddUpdate } from '@/const';

export const routes: RouteObject[] = [
  {
    path: 'settings',
    children: [
      {
        path: `settings${AddUpdate}`,
        element: <SettingsPage appName={'localization'} model={'country'} />,
      },
    ],
  },
];
